var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidStarYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00033 10.3655L10.6053 12.5413L9.64866 8.44051L12.8337 5.68134L8.63949 5.32551L7.00033 1.45801L5.36116 5.32551L1.16699 5.68134L4.35199 8.44051L3.39533 12.5413L7.00033 10.3655Z",
    fill: "#FFE600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidStarYellow);
export default __webpack_public_path__ + "static/media/solid_star_yellow.c82cd0553aee4ff3072249d5ed43740d.svg";
export { ForwardRef as ReactComponent };